import "./LabelledCheckbox.css";


function LabelledCheckbox({ label, checked, onChange, id, name, disabled=false }) {
    const checkboxId = id || name || `checkbox-${label}`.replace(/\s+/g, '-').toLowerCase();

    return (
        <div className="labelled-checkbox">
            <label htmlFor={checkboxId}>
                {label}
            </label>
            <input
                type="checkbox"
                id={checkboxId}
                name={name || checkboxId}
                checked={checked}
                onChange={onChange}
                disabled={disabled}
            />
        </div>
    );
}

export default LabelledCheckbox;